import { apiClient } from './client';
import { Organisation, OrganisationDefaults } from '../../types/api';

export interface CreateOrganisationData {
  name: string;
  displayName: string;
  description?: string;
  perimeterId: number;
  isActive?: boolean;
}

export interface UpdateOrganisationData {
  name?: string;
  displayName?: string;
  description?: string;
  isActive?: boolean;
}

export interface OrganisationService {
  getOrganisations(): Promise<Organisation[]>;
  createOrganisation(data: CreateOrganisationData): Promise<Organisation>;
  updateOrganisation(id: number, data: UpdateOrganisationData): Promise<Organisation>;
  deleteOrganisation(id: number): Promise<void>;
  getUserDefaults(): Promise<OrganisationDefaults>;
  updateUserDefaults(defaults: Partial<OrganisationDefaults>): Promise<OrganisationDefaults>;
}

class OrganisationServiceImpl implements OrganisationService {
  async getOrganisations(): Promise<Organisation[]> {
    return await apiClient.get<Organisation[]>('/organisations');
  }

  async createOrganisation(data: CreateOrganisationData): Promise<Organisation> {
    return await apiClient.post<Organisation>('/organisations', data);
  }

  async updateOrganisation(id: number, data: UpdateOrganisationData): Promise<Organisation> {
    return await apiClient.put<Organisation>(`/organisations/${id}`, data);
  }

  async deleteOrganisation(id: number): Promise<void> {
    await apiClient.delete(`/organisations/${id}`);
  }

  async getUserDefaults(): Promise<OrganisationDefaults> {
    return await apiClient.get<OrganisationDefaults>('/user/defaults');
  }

  async updateUserDefaults(defaults: Partial<OrganisationDefaults>): Promise<OrganisationDefaults> {
    return await apiClient.put<OrganisationDefaults>('/user/defaults', defaults);
  }
}

export const organisationService = new OrganisationServiceImpl();